export default __webpack_public_path__ + "static/media/Magnifier.0bf58106.svg";